/**
 * Hotel compare modal — meal plan pill colors (single place to tweak).
 * Used by `ModalCompare` only. Detection reuses `isFreeBreakfastMealPlan` / `isAllInclusivetMealPlan` from `@utils`.
 */
import { isAllInclusivetMealPlan, isFreeBreakfastMealPlan } from '@utils';

export type ModalCompareMealPlanBadgeKind = 'default' | 'freeBreakfast' | 'allInclusive';

/** Background + text colors for each meal plan badge variant */
export const MODAL_COMPARE_MEAL_PLAN_BADGE_COLORS: Record<
  ModalCompareMealPlanBadgeKind,
  { backgroundColor: string; color: string }
> = {
  /** Grey — e.g. “Breakfast available” and other non-special plans */
  default: {
    backgroundColor: '#ececec',
    color: '#5f6368',
  },
  /** Green — free breakfast (and matching API strings from `isFreeBreakfastMealPlan`) */
  freeBreakfast: {
    backgroundColor: '#e6f4ea',
    color: '#1e8e3e',
  },
  /** Violet — all inclusive (and matching API strings from `isAllInclusivetMealPlan`) */
  allInclusive: {
    backgroundColor: '#ede7f6',
    color: '#6a1b9a',
  },
};

export function getModalCompareMealPlanBadgeKind(mealPLan: string): ModalCompareMealPlanBadgeKind {
  const t = mealPLan.trim();
  if (isAllInclusivetMealPlan(t)) {
    return 'allInclusive';
  }
  if (isFreeBreakfastMealPlan(t)) {
    return 'freeBreakfast';
  }
  return 'default';
}
